import {Component, Input} from '@angular/core';
import {InfluencerPost} from '../../../../../../models/influencer';
import {Router} from '@angular/router';
import {platformIconPathById} from '../../../../../app.constants';
import {DateUtils} from '../../../../../utils/date.utils';
import {UserService} from '../../../../../services/user.service';

@Component({
  selector: 'platform-reach-item',
  templateUrl: './platform-reach-item.component.html',
  styleUrls: ['./platform-reach-item.component.scss']
})
export class PlatformReachItemComponent {

  @Input() platformReach: InfluencerPost = new InfluencerPost();

  constructor(private router: Router, private userService: UserService) { }

  getPlatformIcon(platform): string {
    if (!platform) {
      return '';
    }
    return platformIconPathById[platform.id] && platformIconPathById[platform.id].path;
  }

  formatPublishData(publishDateTimestamp: number): string {
    const publishDate = new Date(publishDateTimestamp);
    return DateUtils.formatDate(publishDate.toString());
  }
  openPostPage() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    // influencer platform version
    if (currentInfluencer) {
      return this.router.navigate(['dashboard', 'post', this.platformReach.urlHash]);
    } else {
      return this.router.navigate(['post'], {queryParams: {
        influencerId: this.platformReach.blog_id,
        urlHash: this.platformReach.urlHash,
        activeAccount: this.userService.getCompanyId()
      }});
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/list-platform-reach/platform-reach-item/platform-reach-item.component.ts